import { ExtendedScrollService } from '@theme/js/services/extended-scroll.service';

export const gameInfoScrollService = new ExtendedScrollService();
